import { apiClient } from "../../../lib";

export const stageGateApi = {

    // checklist mutations
    addCheckList: async (
        payload: {
            task_name: string | null,
            user_id: number | null,
            is_evidence_required: boolean,
            is_required: boolean,
            object_type: string | null;
            object_id?: number | null;
            description?: string | null,
            priority?: string | null,
            status?: string | null,
            target_date?: string | null,
            notes?: string | null
        }): Promise<any> => {
        const response = await apiClient.post(`/tasks`, payload);
        return response.data;
    },
    editCheckList: async (
        payload: {
            task_name: string | null,
            user_id: number | null,
            is_evidence_required: boolean,
            is_required: boolean,
            object_type: string | null;
            object_id?: number | null;
            description?: string | null,
            priority?: string | null,
            status?: string | null,
            target_date?: string | null,
        },
        checkListID: string): Promise<any> => {
        const response = await apiClient.put(`/tasks/${checkListID}`, payload);
        return response.data;
    },
    updateCheckLists: async (checkListID: string, payload: { status: string, object_type: string, object_id?: number | string | null; notes?: string | null }): Promise<any> => {
        const response = await apiClient.put(`/tasks/${checkListID}`, payload);
        return response.data;
    },
    fetchCheckListsDetails: async (checkListID: string): Promise<any> => {
        const response = await apiClient.get(`/tasks/${checkListID}`);
        return response.data;
    },
   fetchCheckLists: async ({ projectId, search_term, object_type, object_id, my_tasks, page, limit, priorityFilter, statusFilter, actionTypeFilter, ownerFilter }: { projectId?: string | undefined, search_term: string | null, object_type: string[] | null, object_id: number | null, my_tasks: boolean, page?: number, limit?: number, priorityFilter?: string[], statusFilter?: string[], actionTypeFilter?: string[], ownerFilter?: string[] }): Promise<any> => {
    const searchParams = new URLSearchParams();
    if (object_type && object_type.length > 0) {
        object_type.forEach(v => searchParams.append('object_type', v));
    }
    if (page && limit) {
        searchParams.append('page', page.toString());
        searchParams.append('limit', limit.toString());
    }
    if (object_id !== null) {
        searchParams.append('object_id', object_id.toString());
    }
    if (search_term !== null) {
        searchParams.append('search_term', search_term.toString());
    }
    if (my_tasks) {
        searchParams.append('assign_to_me', 'true');
    }
    if (priorityFilter && priorityFilter.length > 0) {
        priorityFilter.forEach(v => searchParams.append('priority', v));
    }
    if (statusFilter && statusFilter.length > 0) {
        statusFilter.forEach(v => searchParams.append('status', v));
    }
    if (actionTypeFilter && actionTypeFilter.length > 0) {
        actionTypeFilter.forEach(v => searchParams.append('object_type', v));
    }
    if (ownerFilter && ownerFilter.length > 0) {
        ownerFilter.forEach(v => searchParams.append('user_id', v));
    }
    if (projectId) {
        searchParams.append('project_id', projectId);
    }
    const queryString = searchParams.toString();
    const response = await apiClient.get(`/tasks?${queryString}`);
    return response.data;
},

    // approval mutations

    addApproval: async (stageID: string, payload: { user_id: number, is_decision_gate: boolean }): Promise<any> => {
        const response = await apiClient.post(`/stage-gates/${stageID}/approval`, payload);
        return response.data;
    },
    fetchApprovals: async (stageID: string): Promise<any> => {
        const response = await apiClient.get(`/stage-gates/${stageID}/approval`);
        return response.data;
    },
    editApproval: async (stageID: string, payload: { user_id: number, is_decision_gate: boolean }, approvalID: string): Promise<any> => {
        const response = await apiClient.put(`/stage-gates/${stageID}/approval/${approvalID}`, payload);
        return response.data;
    },
    updateApproval: async (stageID: string, approvalID: string, payload: { status: string, notes: null | string }): Promise<any> => {
        const response = await apiClient.put(`/stage-gates/${stageID}/approval/${approvalID}`, payload);
        return response.data;
    }

};